import { render } from "./KpiSummaryRow.vue?vue&type=template&id=01d49e2a&scoped=true"
import script from "./KpiSummaryRow.vue?vue&type=script&lang=js"
export * from "./KpiSummaryRow.vue?vue&type=script&lang=js"

import "./KpiSummaryRow.vue?vue&type=style&index=0&id=01d49e2a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01d49e2a"]])

export default __exports__